export enum ACTION_TYPE {
  //organization
  ORGANIZATION_SIGNUP = 'organization/signUp',
  ORGANIZATION_GOOGLE_SIGNUP = 'organization/googleSignUp',
  ORGANIZATION_APPLE_SIGNUP = 'organization/appleSignUp',
  ORGANIZATION_LOGIN = 'organization/login',
  ORGANIZATION_LOGOUT = 'organization/logout',
  ORGANIZATION_GET_INFO = 'organization/getInfo',
  CHANGE_ORGANIZATION_PROFILE = 'organization/changeOrganizationProfile',

  //event
  EVENT = 'event/getEvent',
  EVENTS = 'event/getEvents',
  EVENT_TODO_LIST = 'event/getEventTodoList',
  EVENT_SPONSOR_CATEGORIES = 'event/getSponsorCategories',
  EVENT_UPDATE = 'event/updateEvent',
  EVENT_BY_SLUG = 'event/getEventBySlug',

  //dashboard
  DASHBOARD_STATISTICS = 'dashboard/getStatistics',
  DASHBOARD_TABLES_SOLD = 'dashboard/getTablesSold',
  DASHBOARD_UNKNOWN_GUESTS = 'dashboard/getUnknownGuests',
  DASHBOARD_AUCTION_ITEMS = 'dashboard/getAuctionItems',
  DASHBOARD_CHECKED_IN = 'dashboard/getCheckedIn',
  DASHBOARD_SPECIAL_MEALS = 'dashboard/getSpecialMeals',
  DASHBOARD_ATTENTION_LIST = 'dashboard/getAttentionList',

  //tables and tickets
  TABLES_AND_TICKETS_TICKETS_LIST = 'tablesAndTickets/getTicketsList',
  TABLES_AND_TICKETS_TICKETS_TIERS = 'tablesAndTickets/getTicketsListTiers',
  TABLES_AND_TICKETS_STATISTICS = 'tablesAndTickets/getTicketsStatistics',
  TABLES_AND_TICKETS_AVAILABLE = 'tablesAndTickets/getTableAndTicketsAvailable',
  TABLES_AND_TICKETS_TICKETS = 'tablesAndTickets/getTableTickets',
  TABLES_AND_TICKETS_DONATIONS = 'tablesAndTickets/addDonation',
  ORGANIZATION_FUND_DONATION = 'organization/fundDonation',
  TABLES_AND_TICKETS_UPDATE_TICKET_STATUS = 'tablesAndTickets/updateTicketStatus',
  TABLES_AND_TICKETS_TICKETS_TIERS_PRIVATE = 'tablesAndTickets/getPrivateTicketsListTiers',

  //auction
  AUCTION_LIST = 'auction/getAuctionList',
  AUCTION_CATEGORIES = 'auction/getAuctionCategories',
  AUCTION_BIDS = 'auction/getAuctionBids',
  AUCTION = 'auction/getAuction',
  AUCTION_WON_LIST = 'auction/getAuctionWonList',

  //attendee
  ATTENDEE = 'attendee/getAttendee',
  ATTENDEE_BIDS = 'attendee/getAttendeeBids',
  ATTENDEE_STATISTICS = 'attendee/getStatistics',
  ATTENDEES_LIST = 'attendee/getAttendeesList',

  //notifications settings
  NOTIFICATION_SETTING_PHONE_LIST = 'notifications/getNotificationPhoneList',
  NOTIFICATION_SETTING_CREATE_PHONE = 'notifications/createNotificationPhone',
  NOTIFICATION_SETTING_DELETE_PHONE = 'notifications/deleteNotificationPhone',

  NOTIFICATION_SETTING_LIST = 'notifications/getNotificationSettingsList',
  NOTIFICATION_SETTING_UPDATE_LIST = 'notifications/updateNotificationSettingsList',

  //notifications
  NOTIFICATION_LIST = 'notification/getNotificationList',
  NOTIFICATION_UPDATE_STATUS = 'notification/updateNotificationStatus',

  //user
  USER_SIGNUP = 'user/signUp',
  USER_LOGIN = 'user/login',
  USER_LOGOUT = 'user/logout',
  USER_GET_INFO = 'user/getInfo',
  CHANGE_PASSWORD = 'user/changePassword',
  CHANGE_USER_PROFILE = 'organization/changeUserProfile',
  URDATE_RAFFLE_LIST = 'user/updateRaffleList',
  USERS_TABLES_AND_TICKETS = 'user/getUsersTablesAndTickets',

  //team
  TEAM = 'team/getTeam',
  TEAM_CREATE_MEMBER = 'team/createTeamMember',
  TEAM_UPDATE_MEMBER_ROLE = 'team/updateTeamMemberRole',
  TEAM_DELETE_MEMBER = 'team/deleteTeamMember',
  TEAM_GENERATE_PASSWORD = 'team/generateTeamMemberPassword',
  TEAM_PRESIGN_IMAGE = 'team/presignedImage',
  TEAM_GET_TEAM_MEMBER_INFO = 'team/getTeamMemberInfo',
  TEAM_UPDATE_TEAM_MEMBER = 'team/updateTeamMember',

  //admin
  SUPER_ADMIN_LOGIN = 'superAdmin/login',
  SUPER_ADMIN_LOGOUT = 'superAdmin/logout',
  SUPER_ADMIN_GET_INFO = 'superAdmin/getInfo',
  SUPER_ADMIN_UPDATE_PROFILE = 'superAdmin/updateProfile',
  SUPER_ADMIN_GET_ALL_ORGANIZATIONS = 'superAdmin/getAllOrganizations',
  SUPER_ADMIN_GET_ORGANIZATION = 'superAdmin/getOrganization',
  SUPER_ADMIN_GET_ALL_ORGANIZATION_TRANSACTIONS = 'superAdmin/getAllOrganizationTransactions',
  SUPER_ADMIN_GET_ALL_ORGANIZATION_EVENTS = 'superAdmin/getAllOrganizationEvents',
  SUPER_ADMIN_GET_STATISTICS = 'superAdmin/getStatistics',
  SUPER_ADMIN_GET_PLATFORM_FEE = 'superAdmin/getPlatformFee',
  SUPER_ADMIN_LOGIN_2FACTOR = 'superAdmin/login2Factor',

  //report
  REPORT_GET_UNPAID_ITEM = 'report/getUnpaidItem',
  REPORT_GET_UNPAID_TABLE = 'report/getUnpaidTable',
  REPORT_GET_PARTICIPANTS = 'report/getParticipants',
  REPORT_GET_MAX_BIDS = 'report/getMaxBids',
  REPORT_GET_FILE_UNPAID_ITEM = 'report/getFileUnpaidItem',
  REPORT_GET_FILE_UNPAID_TABLE = 'report/getFileUnpaidTable',
  REPORT_GET_FILE_PARTICIPANTS = 'report/getFileParticipants',
  REPORT_GET_FILE_MAX_BIDS = 'report/getFileMaxBids',
  REPORT_GET_REPORTED_COLUMNS = 'report/getReportedColumns',
  REPORT_GET_ATTENDEE_FINANCIAL_REPORT = 'report/getAttendeeFinancialReport',

  //communication
  CREATE_CUSTOMIZATION_TEMPLATE = 'communication/createCustomizationTemplate',
  GET_PRESIGNED_CUSTOMIZATION_TEMPLATE_IMAGE = 'communication/getPresignedCustomizationTemplateImage',
  GET_CUSTOMIZATION_TEMPLATES = 'communication/getCustomizationTemplates',
  GET_All_CUSTOMIZATION_TEMPLATES = 'communication/getAllCustomizationTemplates',
  GET_ONE_CUSTOMIZATION_TEMPLATES = 'communication/getOneCustomizationTemplates',
  UPDATE_ONE_CUSTOMIZATION_TEMPLATES = 'communication/updateOneCustomizationTemplates',

  //attendee contribution
  ATTENDEE_CONTRIBUTIONS_LIST = 'attendeeContribution/getAttendeeContributions',

  //BILING HISTORY
  BILLING_HISTORY_LIST = 'billingHistory/getBillingHistoryList',
}
